export const EmptyState = ({ title, message, action }) => (
  <div className="state-card">
    <h3>{title}</h3>
    <p>{message}</p>
    {action}
  </div>
);
